export const INSTAGRAM_URL = 'https://www.instagram.com/travelwith_choco/';
export const INSTAGRAM_PROFILE_NAME = 'travelwith_choco';
export const IG_POST_URL = 'https://www.instagram.com/p';
export const INSTA_PHOTO_SIZE = 150;
export const LINKEDIN_URL = 'https://www.linkedin.com/in/coco-duan/';
export const PINTEREST_URL = 'https://www.pinterest.com/cocoduan/';
export const YOUTUBE_URL =
  'https://www.youtube.com/channel/UCYuQQEhi03X5BNCU6S2rrog';
export const YOUTBE_EMBED_BASE = 'https://www.youtube.com/embed';
